import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, ContentNode, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { EntityFilters, EntityTypeCardsProvider, ExplorerEntityGridLayout, OrganisationLogoCard, OrganisationMarketMapGrid, SearchBar, useEntityAll, useOrganisations, useSearch, useView } from '@shapeable/ui';
import { compact, sortBy } from 'lodash';
import { linkedMatchesFilter } from '../../utils/linked-matches-filter';
import { useMarketMapFilters } from '../../hooks/use-market-map-filters';
import { Organisation } from '@shapeable/copper-connect-types';
import { classNames, entityGridNameSort } from '@shapeable/utils';

const cls = classNames('explorer-market-map-layout');

// -------- Types -------->

export type ExplorerMarketMapLayoutProps = Classable & HasChildren & {
}

export const ExplorerMarketMapLayoutDefaultProps: ExplorerMarketMapLayoutProps = {

};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`

  `,
});

const FiltersStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  Container: styled(ExplorerEntityGridLayout)<ContainerProps>`${ContainerStyles}`,
    Filters: styled(EntityFilters)`${FiltersStyles}`,
};

export const ExplorerMarketMapLayout: Shapeable.FC<ExplorerMarketMapLayoutProps> = (props) => {
  const { className } = props;

  // const organisationsQuery = useEntityAll('Organisation');

  const organisationItems = useOrganisations() as Organisation[];
  const allOrganisations = entityGridNameSort(organisationItems);

  const marketMapFilters = useMarketMapFilters('explorer-community');
  const { selects } = marketMapFilters;

  const view = 'explorer';
  const { filters, selectedTypes } = useView(view);
  
  const { countries = [], types = [], technologies = [], themes = [] } = filters;

  const organisations = allOrganisations.filter((organisation: Organisation) => (
      linkedMatchesFilter(compact([organisation?.type]), types) &&
      linkedMatchesFilter([organisation.country], countries) &&
      linkedMatchesFilter(organisation.technologies, technologies) && 
      linkedMatchesFilter(organisation?.trends, themes) && 
      linkedMatchesFilter(organisation?.partnerOrganisations, selectedTypes)
    ));

  const description: ContentNode = {
    text: 'This listing of key organisations and innovators across the world is provided as an information source for further research. Unless badged as Partners or Members, they currently have no affiliation.',
  };

  return (
    <My.Container 
      className={cls.name(className)} 
      view={view}
      showSearchBar
      items={organisations}
      spacing={4}
      description={description}
      // loading={organisationsQuery.loading}
      filters={
        <My.Filters 
          view={view}
          results={allOrganisations}
          selects={selects}
          typeToggles={[
            { label: 'Austmine Members', name: 'austmine' },
          ]}
        />
      }
    />
  )
};

ExplorerMarketMapLayout.cls = cls;
ExplorerMarketMapLayout.defaultProps = ExplorerMarketMapLayoutDefaultProps;